import React from 'react';

// Digital HIG Components
// @ts-ignore
import DHBox from "@digital-hig/mui/Box";
// @ts-ignore
import DHTypography from "@digital-hig/mui/Typography";

interface DownloadMessageProps {
  onDownloadAgain?: () => void;
  downloadUrl?: string;
}

export const DownloadMessage: React.FC<DownloadMessageProps> = ({ onDownloadAgain, downloadUrl }) => {
  return (
    <DHBox
      sx={{
        padding: 2,
        backgroundColor: '#ffffff',
        borderRadius: 1,
        minHeight: '60px'
      }}
    >
      <DHTypography
        variant="caption"
        sx={{
          fontFamily: 'Artifakt Element',
          fontWeight: 400,
          fontSize: '16px',
          lineHeight: '150%',
          letterSpacing: '0%',
          color: 'ink-on-background'
        }}
      >
        Configuration file download started. Check your Downloads folder when it completes. If your downloads doesn't automatically begin,{' '}
        {downloadUrl ? (
          <a
            href={downloadUrl}
            download="AdskDeviceSettingConfig.json"
            style={{
              textDecoration: 'underline',
              cursor: 'pointer',
              color: 'inherit'
            }}
          >
            download again
          </a>
        ) : (
          <span
            style={{
              textDecoration: 'underline',
              cursor: 'pointer'
            }}
            onClick={onDownloadAgain}
          >
            download again
          </span>
        )}
        .
      </DHTypography>
    </DHBox>
  );
};

